import { PageQueryParams } from '../domain/response-wrapper';
import { useQueryParams } from './useQueryParams';

export const usePagination = <T extends PageQueryParams>(initialParams: T) => {
  const { updateParams, setParam, queryParams } = useQueryParams<T>(initialParams);

  const nextPage = () => {
    if (queryParams) {
      goToPage(Number(queryParams.page) + 1);
    }
  };

  const prevPage = () => {
    if (queryParams) {
      goToPage(Math.max(0, Number(queryParams.page) - 1));
    }
  };

  const goToPage = (page: number) => {
    setParam('page', page);
  };

  const search = (key: keyof T, value: any) => {
    queryParams.page = 0;
    setParam(key, value);
  };


  return {
    queryParams,
    updateParams,
    setParam,
    nextPage,
    prevPage,
    goToPage,
    search,
  };
};
